module.exports = __webpack_public_path__ + "static/media/Aerospace.8eb165b9.png";